const actions = {
  GET_RESERVATIONS_HISTORY_REQUEST: "GET_RESERVATIONS_HISTORY_REQUEST",
  GET_RESERVATIONS_HISTORY_SUCCESS: "GET_RESERVATIONS_HISTORY_SUCCESS",

  getReservationsHistory: (getReservationHistoryData) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_RESERVATIONS_HISTORY_REQUEST,
        getReservationHistoryData,
      });
    };
  },
};

export default actions;
